<label class="label" [innerHTML]="field.templateOptions.label | safeHtml: 'html'"></label>
<ng-container #fieldComponent></ng-container>
